<template>
  <div class="dashboard_left absolute">
    <div style="display: flex; flex-flow: column; height: 100%">
      <div class="contain_center">
        <!-- 公共title -->
        <Top :name="$t('Unit Information')" :show-button="false"></Top>
        <div class="top_data">
          <EquipInfo :equip_data="equip_data"></EquipInfo>
        </div>
      </div>
      <!-- 公共title -->
      <div class="contain_footer">
        <!-- 公共title -->
        <div class="relative">
          <SelectTop
            :name="$t('Maintenance Service')"
            :button-name="selectPlan[currentSelect]"
            v-model:currentSelect="currentSelect"
          ></SelectTop>
        </div>
        <div class="footer_data position-relative">
          <div  v-if="equip_data.product_type != '1'" class="w-100 d-flex align-items-center mt-2 mb-2 fs-18">
            <div class="label-icon"></div>
            <div>{{ equip_data_plan.name }}</div>
          </div>
          <NextPlan
            :planList="planList"
            :equip_data="equip_data_plan"
            v-if="currentSelect == 'next'"
          ></NextPlan>
          <PrePlan
            :planList="planList"
            :equip_data="equip_data_plan"
            v-else
          ></PrePlan>
          <div
            v-if="equip_data.product_type != '1'"
            style="position: absolute; bottom: 20px; left: 0px"
            class="d-flex justify-content-center align-items-center w-100"
          >
            <img
            v-show="planIndex != 0"
              style="width: 40px"
              @click="changePlan('pre')"
              class="me-3"
              src="./left.svg"
              alt="#"
            />
            <img
            v-show="equip_data.children&&planIndex != equip_data.children.length - 1"
              style="width: 40px"
              @click="changePlan('next')"
              class="ms-3"
              src="./right.svg"
              alt="#"
            />
          </div>
        </div>
      </div>
      <div v-if="false" class="mapBox" id="mapBox">
  
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import EquipInfo from "./component/EquipInfo";
// import EquipWarning from "./component/EquipWarning";
import NextPlan from "./component/NextPlan";
import PrePlan from "./component/PrePlan";
import SelectTop from "@/components/common/SelectTop.vue";
import { shallowRef } from "@vue/reactivity";
import { deviceMaintainItem } from "@/service";
import _ from "lodash";
import {IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common.js";
export default {
  setup() {
    const map = shallowRef(null);
    return {
      map,
    };
  },
  props: ["equip_data", "equip_data_info_list","router_equip_data"],
  data() {
    return {
      currentSelect: "next",
      planList: {},
      planIndex: 0,
    };
  },
  computed: {
    selectPlan() {
      return {
        next: this.$t("Next Service Plan"),
        pre: this.$t("Last Service Record"),
      };
    },
    equip_data_plan() {
      if (
        this.equip_data.children &&
        this.equip_data.children.length > 0 &&
        this.equip_data.product_type == "2"
      ) {
        return _.cloneDeep(this.equip_data.children[this.planIndex], {});
      } else {
        return _.cloneDeep(this.equip_data, {});
      }
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }
  },
  watch: {
    // equip_data: {
    //   handler(val) {
    //     if (val && val.id) {
    //       this.getDeviceMaintainItem();
    //     }
    //   },
    // },
    currentSelect: {
      handler() {
        this.getDeviceMaintainItem();
      },
      deep: true,
    },
    equip_data_plan: {
      handler(newVal, oldVal) {
       if(newVal&&(newVal.id != oldVal.id)) this.getDeviceMaintainItem();
      },
      deep: true,
    },
  },
  methods: {
    changePlan(type) {
      switch (type) {
        case "next":
          if (this.planIndex == this.equip_data.children.length - 1) {
            this.planIndex = this.equip_data.children.length - 1;
          } else {
            this.planIndex++;
          }
          break;
        case "pre":
          if (this.planIndex < 0) {
            this.planIndex = 0;
          } else if(this.planIndex>0){
            this.planIndex--;
          }
          break;
      }
    },
    getDeviceMaintainItem() {
      this.planList = [];
      if(this.isPaperMaking){ //造纸厂展示内容
        this.planList =  {
          "last_maintain_item_data": null,
          "last_maintenance_date": "-",
          "last_maintenance_item": "-",
          "maintain_item_data": ["汽水分离器滤网","需更换润滑油","更换润滑油滤芯","清理油站冷却器滤芯","清理透平机叶轮","更换透平机轴承","清洗冷却风机滤袋","更换冷却风机滤袋"],
          "next_maintenance_date": this.equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID ? "2026-12-29":"2026-04-27",
          "next_maintenance_item": "4"//日常保养
        }
      }else{
        if(this.equip_data_plan.id){
          deviceMaintainItem(this.equip_data_plan.id).then((res) => {
            // console.log(res)
            this.planList = res.payload;
          });
        }
      } 
    },
    initMap() {
      AMapLoader.load({
        key: "	d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("mapBox", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 5, //初始化地图级别
            center: [105.602725, 37.076636], //初始化地图中心点位置
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  components: {
    EquipInfo,
    // EquipWarning,
    NextPlan,
    PrePlan,
    SelectTop,
  },
  mounted() {
    // console.log(this.equip_data);
    //  this.initMap();
    this.getDeviceMaintainItem()
  },
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");

.dashboard_left {
  width: 400px;
  height: 100%;
  top: 0;
  left: 0;

  .contain_top,
  .contain_center,
  .contain_footer,
  .mapBox {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    margin-bottom: 10px;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 20px 20px 10px;
    flex-flow: column;
    .top_data {
      flex: 1;
    }
  }
  .contain_top {
    height: 30%;
    flex: 1;
  }
  .contain_center {
    height: 35%;
    .top_data {
      height: 90%;
    }
  }
  .contain_footer {
    height: 65%;
    margin-bottom: 0;
    .footer_data {
      height: 100%;
    }
  }
  .mapBox {
    height: 20%;
    margin-top: 10px;
    padding: 0px;
  }
}
.label-icon {
  display: inline-block;
  margin-right: 5px;
  width: 3px;
  height: 10px;
  background: #74778c;
}
</style>
